import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { acceptUrl: String, mergeUrl: String }
  static targets = ["form", "acceptInput", "mergeInput", "response", "toggleRadio",
    "acceptSubmitButton", "mergeSubmitButton"]

  initialize() {
    this.disableMergeSubmitButton()
    this.toggleRadioTarget.addEventListener("toggle-radio-value-changed", (event) => this.toggleRadioEventListener(event))
  }

  submitAccept(event) {
    event.preventDefault()

    if (confirm("Are you sure you want to accept this name?")) {
      this.formTarget.action = this.acceptUrlValue
      this.formTarget.submit()
    }
  }

  submitMerge(event) {
    event.preventDefault()

    let selectedValue
    this.mergeInputTargets.forEach((input) => {
      if (input.checked) {
        selectedValue = input.value
        return
      }
    })

    if (selectedValue === undefined) {
      alert("Please select a merge option")
    } else {
      if (confirm("Are you sure you want to merge this name?")) {
        this.formTarget.action = this.mergeUrlValue
        this.formTarget.submit()
      }
    }
  }

  toggleRadioEventListener(event) {
    if (event.detail) {
      this.enableMergeSubmitButton()
    } else {
      this.disableMergeSubmitButton()
    }
  }

  enableMergeSubmitButton() {
    this.acceptSubmitButtonTarget.classList.add("hidden")
    this.mergeSubmitButtonTarget.classList.remove("hidden")
  }

  disableMergeSubmitButton() {
    this.acceptSubmitButtonTarget.classList.remove("hidden")
    this.mergeSubmitButtonTarget.classList.add("hidden")
  }
}
